module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-4.329362e5.jpeg";